export const investorCrmInvestorsArticle = {
  title: 'Investor CRM: Investors Tab',
  slug: 'investor-crm-investors',
  content: `Investor CRM: Investors Tab

Use the Investors tab to manage investor profiles.

1) Search and filter
- Search by company or contact name.
- Filter by stage or investor type.

2) Switch views
- Table, Kanban, and Gallery views are available.

3) Quick add
- Use the Quick Add form to create a new investor.
- Company name is required; stage and contact name are optional.

4) Manage details
- Click “Manage” to open the investor drawer.
- Update profile fields and log activities.
`,
};
